import { StationUnit } from "@/models/stationUnit.js"




export class ServiceUnit extends StationUnit {
	// Passport keys in DB
	static get passportKeys() {
		return Object.freeze({
			self: 'service_unit',
			unitVersion: 'unit_version',
			unitPort: 'unit_port',
			unitModbusAddr: 'unit_modbus_addr',
			// Power counter settings
			pwrCntStart: 'pwr_cnt_start_value',
			pwrCounterK: 'pwr_counter_k',

			// Akkumulator settings
			akkEmptyVoltage: 'akk_empty_voltage',
			akkFullVoltage: 'akk_full_voltage',

			clockSynchronization: 'clock_synchronization',

			u220Min: 'u220_min',
			u220Max: 'u220_max',
			u220ThresholdHandler: 'u220_threshold_handler',
			u220Adjust: 'u220_adjust',
			u220ShiftA: 'u220_shift_A',
			u220ShiftB: 'u220_shift_B',

			channel1InpMin: 'channel_1_inp_min',
			channel1InpMax: 'channel_1_inp_max',
			channel1ThresholdHandler: 'channel_1_threshold_handler',
			channel1Adjust: 'channel_1_adjust',
			channel1ShiftA: 'channel_1_shift_A',
			channel1ShiftB: 'channel_1_shift_B',

			
			channel2InpMin: 'channel_2_inp_min',
			channel2InpMax: 'channel_2_inp_max',
			channel2ThresholdHandler: 'channel_2_threshold_handler',
			channel2Adjust: 'channel_2_adjust',
			channel2ShiftA: 'channel_2_shift_A',
			channel2ShiftB: 'channel_2_shift_B',

			shuntMin: 'shunt_min',
			shuntMax: 'shunt_max',
			shuntThresholdHandler: 'shunt_threshold_handler',
			shuntAdjust: 'shunt_adjust',
			shuntShiftA: 'shunt_shift_A',
			shuntShiftB: 'shunt_shift_B',

			securityCircuit_1_purpose: 'security_circuit_1_purpose',
			securityCircuit_2_purpose: 'security_circuit_2_purpose',
			securityCircuit_3_purpose: 'security_circuit_3_purpose',
			securityCircuit_4_purpose: 'security_circuit_4_purpose',
			securityCircuit_5_purpose: 'security_circuit_5_purpose',
			securityCircuit_6_purpose: 'security_circuit_6_purpose',
			securityCircuit_1_handler: 'security_circuit_1_handler',
			securityCircuit_2_handler: 'security_circuit_2_handler',
			securityCircuit_3_handler: 'security_circuit_3_handler',
			securityCircuit_4_handler: 'security_circuit_4_handler',
			securityCircuit_5_handler: 'security_circuit_5_handler',
			securityCircuit_6_handler: 'security_circuit_6_handler',

			relatedRpc: 'related_rpc',
		})
	}

	// Metric keys in DB
	static get metricKeys() {
		return Object.freeze({
			eMin: 'Uprotect_min',
			eAvg: 'Uprotect_avg',
			eMax: 'Uprotect_max',
			u220: 'U220',
			tOutdoor: 'Toutdoor',
			extPwrCounterImpl: 'ext_pwr_counter_impl',
			extPwrCounterEnergy: 'ext_pwr_counter_energy',
			//
			uChannel1: 'Uch1',
			uChannel2: 'Uch2',
			iOut: 'Ushunt',
			uAkk: 'Uakk',
			// Clock
			clockYear: 'clock_year',
			clockMonth: 'clock_month',
			clockDay: 'clock_day',
			clockHour: 'clock_hour',
			clockMinute: 'clock_minute',
			clockSecond: 'clock_second',
			//
			lastConnection: 'last_connection',
			// alerts
			fSecurityCircuit_1: 'f_security_circuit_1',
			fSecurityCircuit_2: 'f_security_circuit_2',
			fSecurityCircuit_3: 'f_security_circuit_3',
			fSecurityCircuit_4: 'f_security_circuit_4',
			fSecurityCircuit_5: 'f_security_circuit_5',
			fSecurityCircuit_6: 'f_security_circuit_6',
			fSecurityCircuitBoxDoor: 'security_circuit_box_door',
			fSecurityCircuitShelterDoor: 'security_circuit_shelter_door',
			// Flags
			fExternalPwr: 'f_external_pwr',
			//
			isConnect: 'is_connection',
		})
	}

	// Unit versions
	static get versions() {
		return Object.freeze({
			'2022-1': '2022-1',
			'2022-2': '2022-2',
			'2024-1': '2024-1',
			'2024-2': '2024-2',
			'2025-1': '2025-1',
			'2025-2': '2025-2',
			'2025-3': '2025-3',
			unknown: 'unknown',
		})
	}

	// Unit version names
	static get versionNames() {
		const titles = new Object()
		titles[ServiceUnit.versions.unknown] = 'відсутній'
		titles[ServiceUnit.versions['2022-1']] = '2022-1'
		titles[ServiceUnit.versions['2022-2']] = '2022-2'
		titles[ServiceUnit.versions['2024-1']] = '2024-1'
		titles[ServiceUnit.versions['2024-2']] = '2024-2'
		titles[ServiceUnit.versions['2025-1']] = '2025-1'
		titles[ServiceUnit.versions['2025-2']] = '2025-2'
		titles[ServiceUnit.versions['2025-3']] = '2025-3'
		return titles
	}

	get passport() {
		return this._passport.get(ServiceUnit.passportKeys.self)
	}

	// Return true if unit version is not unknown
	get isPresent() {
		if (!this.passport 
			|| !this.passport[ServiceUnit.passportKeys.unitVersion]
			|| this.passport[ServiceUnit.passportKeys.unitVersion] == ServiceUnit.versions.unknown
		) {
			return false
		} else {
			return true
		}
	}

	// Return unit connection metric
	get isConnect() {
		// If not present
		if (!this.isPresent) {
			return false
		}

		if (this.metrics.has(ServiceUnit.metricKeys.isConnect)) {
			return this.metrics.get(ServiceUnit.metricKeys.isConnect).value
		} else {
			return false
		}
	}

	get connectionText() {
		return ServiceUnit.connectionText(this.isConnect)
	}

	// Unit setting names for interface
	static get settingNames() {
		return Object.freeze({
			[ServiceUnit.passportKeys.unitVersion]: 'Версія сервісного модуля',
			[ServiceUnit.passportKeys.unitPort]: 'Порт сервісного модуля',
			[ServiceUnit.passportKeys.unitModbusAddr]: 'ModBus адреса сервісного модуля',
			[ServiceUnit.passportKeys.pwrCntStart]: 'Початкові показники',
			[ServiceUnit.passportKeys.pwrCounterK]: 'Коеффіцієнт перетворення лічильника єлектроенергії',
			[ServiceUnit.passportKeys.akkEmptyVoltage]: 'Напруга, що відповідає 0%',
			[ServiceUnit.passportKeys.akkFullVoltage]: 'Напруга, що відповідає 100%',
			[ServiceUnit.passportKeys.clockSynchronization]: 'Автоматично синхронізувати при відхиленні більше ніж 10 хвилин',

			[ServiceUnit.passportKeys.u220Min]: 'Живлення 220В Uмін, В',
			[ServiceUnit.passportKeys.u220Max]: 'Живлення 220В Uмакс, В',
			[ServiceUnit.passportKeys.u220ThresholdHandler]: 'Аварійне відпрацювання виходу за межі напруги мережі 220В',
			[ServiceUnit.passportKeys.u220Adjust]: 'Калібрування канала вимірювання напруги живлення 220В',
			[ServiceUnit.passportKeys.u220ShiftA]: 'Живлення 220В Коефіцієнт A перетворення (Ax + B)',
			[ServiceUnit.passportKeys.u220ShiftB]: 'Живлення 220В Коефіцієнт B перетворення (Ax + B)',

			[ServiceUnit.passportKeys.channel1InpMin]: 'Канал 1 Uмін, В',
			[ServiceUnit.passportKeys.channel1InpMax]: 'Канал 1 Uмакс, В',
			[ServiceUnit.passportKeys.channel1ThresholdHandler]: 'Аварійне відпрацювання виходу за межі напруги канала 1',
			[ServiceUnit.passportKeys.channel1Adjust]: 'Калібрування канала 1',
			[ServiceUnit.passportKeys.channel1ShiftA]: 'Канал 1 Коефіцієнт A перетворення (Ax + B)',
			[ServiceUnit.passportKeys.channel1ShiftB]: 'Канал 1 Коефіцієнт B перетворення (Ax + B)',

			[ServiceUnit.passportKeys.channel2InpMin]: 'Канал 2 Uмін, В',
			[ServiceUnit.passportKeys.channel2InpMax]: 'Канал 2 Uмакс, В',
			[ServiceUnit.passportKeys.channel2ThresholdHandler]: 'Аварійне відпрацювання виходу за межі напруги канала 2',
			[ServiceUnit.passportKeys.channel2Adjust]: 'Калібрування канала 2',
			[ServiceUnit.passportKeys.channel2ShiftA]: 'Канал 2 Коефіцієнт A перетворення (Ax + B)',
			[ServiceUnit.passportKeys.channel2ShiftB]: 'Канал 2 Коефіцієнт B перетворення (Ax + B)',

			[ServiceUnit.passportKeys.shuntMin]: 'Шунт Uмін, В',
			[ServiceUnit.passportKeys.shuntMax]: 'Шунт Uмакс, В',
			[ServiceUnit.passportKeys.shuntThresholdHandler]: 'Аварійне відпрацювання виходу за межі напруги шунта',
			[ServiceUnit.passportKeys.shuntAdjust]: 'Калібрування канала шунта',
			[ServiceUnit.passportKeys.shuntShiftA]: 'Шунт Коефіцієнт A перетворення (Ax + B)',
			[ServiceUnit.passportKeys.shuntShiftA]: 'Шунт Коефіцієнт B перетворення (Ax + B)',

			[ServiceUnit.passportKeys.securityCircuit_1_purpose]: 'Призначення контура 1',
			[ServiceUnit.passportKeys.securityCircuit_2_purpose]: 'Призначення контура 2',
			[ServiceUnit.passportKeys.securityCircuit_3_purpose]: 'Призначення контура 3',
			[ServiceUnit.passportKeys.securityCircuit_4_purpose]: 'Призначення контура 4',
			[ServiceUnit.passportKeys.securityCircuit_5_purpose]: 'Призначення контура 5',
			[ServiceUnit.passportKeys.securityCircuit_6_purpose]: 'Призначення контура 6',
			[ServiceUnit.passportKeys.securityCircuit_1_handler]: 'Реакція на зміну стану контура 1',
			[ServiceUnit.passportKeys.securityCircuit_2_handler]: 'Реакція на зміну стану контура 2',
			[ServiceUnit.passportKeys.securityCircuit_3_handler]: 'Реакція на зміну стану контура 3',
			[ServiceUnit.passportKeys.securityCircuit_4_handler]: 'Реакція на зміну стану контура 4',
			[ServiceUnit.passportKeys.securityCircuit_5_handler]: 'Реакція на зміну стану контура 5',
			[ServiceUnit.passportKeys.securityCircuit_6_handler]: 'Реакція на зміну стану контура 6',
		})
	}

	static get securityCircuitKeys() {
		return [
			ServiceUnit.metricKeys.fSecurityCircuit_1,
			ServiceUnit.metricKeys.fSecurityCircuit_2,
			ServiceUnit.metricKeys.fSecurityCircuit_3,
			ServiceUnit.metricKeys.fSecurityCircuit_4,
			ServiceUnit.metricKeys.fSecurityCircuit_5,
			ServiceUnit.metricKeys.fSecurityCircuit_6,
			ServiceUnit.metricKeys.fSecurityCircuitBoxDoor,
			ServiceUnit.metricKeys.fSecurityCircuitShelterDoor,
		]
	}

	static securityCircuitKeyToCircuitNum(key) {
		const matchingTable = new Object ()
		matchingTable[ServiceUnit.metricKeys.fSecurityCircuit_1] = 1
		matchingTable[ServiceUnit.metricKeys.fSecurityCircuit_2] = 2
		matchingTable[ServiceUnit.metricKeys.fSecurityCircuit_3] = 3
		matchingTable[ServiceUnit.metricKeys.fSecurityCircuit_4] = 4
		matchingTable[ServiceUnit.metricKeys.fSecurityCircuit_5] = 5
		matchingTable[ServiceUnit.metricKeys.fSecurityCircuit_6] = 6
		
		return matchingTable[key]
	}

	static get securityCircuitPurposeNames() {
		return Object.freeze({
			'not_assigned': 'без призначення',
			'box_door': 'дверцята СКЗ',
			'shelter_door': 'дверцята укриття',
		})
	}

	static alertPromt(key, value) {
		if (ServiceUnit.securityCircuitKeys.includes(key)) {
			const circuit = ServiceUnit.securityCircuitKeyToCircuitNum(key)
			//console.log("serviceUnitAlertPromt", value)
			switch (value) {
				case 0:
					return `Контур ${circuit}: помилка (К.З.)`
				case 1:
					return `Контур ${circuit}: норма (замкнуто)`
				case 2:
					return `Контур ${circuit}: спрацював (розімкнуто)`
				default:
					return `Не визначено`
			}
		} else {
			return '-'
		}
	}

	static get channelTrasholdHandlers() {
		return [
			{code: 0, title: 'не реагувати на вихід за межі'},
			{code: 1, title: 'реагувати на вихід за нижню межу'},
			{code: 2, title: 'реагувати на вихід за нижню межу і повернення до норми'},
			{code: 3, title: 'реагувати на вихід за верхню межу'},
			{code: 4, title: 'реагувати на вихід за верхню межу і повернення до норми'},
			{code: 5, title: 'реагувати на вихід за будь-яку межу'},
			{code: 6, title: 'реагувати на вихід за будь-яку межу і повернення до норми'},
		]
	}

	static get securityCircuitHandlers() {
		return [
			{code: 0, title: 'не реагувати на аварію'},
			{code: 1, title: 'реагувати тільки на аварію і без сирени'},
			{code: 2, title: 'реагувати тільки на аварію і з сиреною'},
			{code: 3, title: 'реагувати на аварію та повернення до норми і без сирени'},
			{code: 4, title: 'реагувати на аварію та повернення до норми і з сиреною'},
		]
	}

	get activeSecurityCircuits() {
		const serviceUnitVersion = this.passport[ServiceUnit.passportKeys.unitVersion]
		const showHnd = [1,2,3,4]
		let result = []

		if (serviceUnitVersion == ServiceUnit.versions.unknown) {
			return result
		}
		
		if (showHnd.includes(this.passport[ServiceUnit.passportKeys.securityCircuit_1_handler])) {
			result.push(1)
		}
		if (showHnd.includes(this.passport[ServiceUnit.passportKeys.securityCircuit_2_handler])) {
			result.push(2)
		}
		if (showHnd.includes(this.passport[ServiceUnit.passportKeys.securityCircuit_3_handler])) {
			result.push(3)
		}

		if ([
			ServiceUnit.versions['2025-1'],
			ServiceUnit.versions['2025-2'],
			ServiceUnit.versions['2025-3'],
		].includes(serviceUnitVersion)) {
			return result
		}

		if (showHnd.includes(this.passport[ServiceUnit.passportKeys.securityCircuit_4_handler])) {
			result.push(4)
		}
		if (showHnd.includes(this.passport[ServiceUnit.passportKeys.securityCircuit_5_handler])) {
			result.push(5)
		}
		if (showHnd.includes(this.passport[ServiceUnit.passportKeys.securityCircuit_6_handler])) {
			result.push(6)
		}

		return result
	}

	static get boxDoorStateCodes() {
		return Object.freeze({
			short: 0,
			close: 1,
			open: 2,
		})
	}

	static boxDoorStatePromt(value) {
		switch(value) {
			case ServiceUnit.boxDoorStateCodes.short:
				return `помилка в контурі`
			case ServiceUnit.boxDoorStateCodes.close:
				return `закрито`
			case ServiceUnit.boxDoorStateCodes.open:
				return `відкрито`
			default:
				return `невідомо`
		}
	}
}